<template>
  <div class='containerDiv' >      
        <ul class="pagination" v-show='pagesInfo.length > 1' >
            <li v-for='(n, index) in pagesInfo'>                
                <span v-on:click='GoToUrl(n)'  ><router-link v-bind:to="n" tag='a'> <span>{{index+1}}</span></router-link></span>
            </li>            
        </ul>
  </div>
</template>

<script>
import { eventBus } from '../../main';
export default {  
  data: function () {     
    return {
       
    }
  },
  mounted: function () {        
           
  },
  methods: {
     GoToUrl: function(n){                        
        this.$router.push(n);        
        //this.$router.go(n);        
    }, 
  },
  filters: {
     
  },
  computed: {
    
  },
  props:['pagesInfo']
}
</script>

<style scoped>
  .containerDiv{
    margin-left: 50px;
  }

  @media screen and (max-width: 981px) {  
    .containerDiv{
        margin-left: 15px;
        font-size: 3em;
    }

    span {
      margin-left: 15px;
      margin-right: 15px;
    }
  }
 
</style>



// WEBPACK FOOTER //
// Pagination.vue?64ae9c22